import React from "react";
import { Link } from "react-router-dom";
import Reveal from "../common/Reveal";

const ClosingCTA = () => {
  return (
    <section className="bg-primary-950 py-16">
      <Reveal className="mx-auto max-w-2xl px-4 text-center sm:px-6 lg:px-8">
        <p className="break-keep text-xl font-bold leading-relaxed text-white sm:text-2xl">
          다음 성공 사례의 주인공이 되어보세요.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <a
            href="mailto:mtst@mtstech.kr"
            className="inline-flex items-center rounded-md bg-white px-6 py-3 text-base font-semibold text-primary-900 transition-all duration-200 hover:-translate-y-0.5 hover:bg-gray-100 hover:shadow-lg"
          >
            도입 문의
          </a>
          <Link
            to="/technology"
            className="inline-flex items-center rounded-md border border-primary-700 px-6 py-3 text-base font-semibold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-primary-900"
          >
            솔루션 더 보기
          </Link>
        </div>
      </Reveal>
    </section>
  );
};

export default ClosingCTA;
